<ng-container *ngIf="status$ | async as status">
    <a
        [ngSwitch]="status"
        class="position-fixed btn-floating btn-lg btn-default waves-effect waves-light btn--chat"
        (click)="onToggle(status)"
    >
        <i class="fas fa-times" *ngSwitchCase="'opened'"></i>
        <i class="far fa-comments" *ngSwitchCase="'closed'"></i>
    </a>
</ng-container>
